import React, {PureComponent} from "react"
import {match as Match} from "react-router"

import {IndexRedirect, NestedRoute} from "@irati/utils/history/routing"

import {ManageUsers} from "../containers/Users/ManageUsers/ManageUsers"
import AddOnePerson from "../containers/Users/AddOnePerson/AddOnePerson"
import AddMultiplePeople from "../containers/Users/AddMultiplePeople/AddMultiplePeople"
import EditPerson from "../containers/Users/EditPerson"
import DeactivateMultiplePeople from "../containers/Users/DeactivateMultiplePeople"

interface Props {
  match: Match
}

class UserSettings extends PureComponent<Props> {
  render() {
    const {match} = this.props

    return (
      <>
        <IndexRedirect match={match} to="/view" />
        <NestedRoute
          component={ManageUsers}
          exact
          match={match.url}
          path="/view"
          title="View Users" />
        <NestedRoute
          component={AddOnePerson}
          exact
          match={match.url}
          path="/add/single"
          title="Add one person" />
        <NestedRoute
          component={AddMultiplePeople}
          exact
          match={match.url}
          path="/add/multiple"
          title="Add multiple people" />
        <NestedRoute
          component={EditPerson}
          exact
          match={match.url}
          path="/edit/:id"
          title="Edit a person" />
        <NestedRoute
          component={DeactivateMultiplePeople}
          exact
          match={match.url}
          path="/deactivate"
          title="Bulk deactivate people" />
      </>
    )
  }
}

export default UserSettings
